import React from 'react';
import PropTypes from 'prop-types';

function IconPause({ size = 40, color = `#01FF95`, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width={size} height={size} rx={size / 2} fill={color}/>
      <rect x="22.7999" y="12" width="4.2" height="16.3333" fill="#0F0F10"/>
      <rect x="13" y="12" width="4.2" height="16.3333" fill="#0F0F10"/>
    </svg>
  )
}

IconPause.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string,
  className: PropTypes.string
}

export default IconPause;
